import React from 'react';
import Image from 'next/image';
import { ITemplateData } from '@/services/template-data-service';
import styles from './CustomerRating.module.scss';

export const CustomerRating = ({ data }: { data: ITemplateData }) => {
  const { link, icon, text, score, reviewCount } = data.customerRatings;
  const { logo, phone } = data.sector;

  const structuredData = {
    '@context': 'http://schema.org/',
    '@type': 'AggregateRating',
    itemReviewed: {
      '@type': 'Organization',
      image: logo,
      name: 'Carel Lurvink',
      url: 'https://www.carellurvink.nl',
      telephone: phone,
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Marssteden 40',
        addressLocality: 'Enschede',
        addressRegion: 'Overijssel',
        postalCode: '7547 TC',
        addressCountry: 'NL'
      }
    },
    ratingValue: score,
    bestRating: 10,
    ratingCount: reviewCount
  };

  return (
    <div className={styles.customerRatings}>
      <a href={link.href} target="_new">
        <Image src={icon.src} alt={icon.alt || ''} width={icon.width} height={icon.height} />
      </a>

      <a href={link.href} target="_new">
        {text}
      </a>

      <span className="score">{score}/10.0</span>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
    </div>
  );
};
